const typography = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em",
  },

  lineHeights: {
    "ms-80": "5rem",
    "ms-62": "3.875rem",
    "ms-40": "2.5rem",
    "ms-34": "2.125rem",
    "ms-32": "2rem",
    "ms-28": "1.75rem",
    "ms-24": "1.5rem",
    "ms-22": "1.375rem",
    "ms-20": "1.25rem",
    "ms-18": "1.125rem",
    "ms-16": "1rem",
   
  },

  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },

  fonts: {
    heading: "Poppins",
    body: "Open sans",
  },

  fontSizes: {
    "ms-60": "3.75rem",
    "ms-48": "3rem",
    "ms-34": "2.125rem",
    "ms-24": "1.5rem",
    "ms-20": "1.25rem",
    "ms-18": "1.125rem",
    "ms-16": "1rem",
    "ms-14": "0.875rem",
    "ms-12": "0.75rem",
    "ms-10": "0.625rem",
  },
};

export default typography;
